import { useField, UseFieldProps } from "formik";
import LAComplete from "./LAComplete";

type IProps = {
	fullWidth?: boolean;
	label: string;
	maxYear: number;
} & Exclude<UseFieldProps<any>, "format">;

export default function LAYearDatePicker(props: IProps) {
	const { format, maxYear, ...other } = props;
	const [field] = useField(other);
	const defaultOptions = [...Array(150)].map((_, i) => maxYear - i);

	return (
		<LAComplete
			{...other}
			{...field}
			title={props.label}
			options={defaultOptions}
			getOptionLabel={(o: any) => `${o}`}
			isChildInFormik
			disableClearable
			savedOnBlur
		/>
	);
}
